import { findString } from './findString';
import {
  ITopicFilterState,
  TopicFilterNames,
} from 'components/TopicFilters/shared';
import { ICustomer } from 'redux/reducers/customers';

/**
 * Constructs an array of customer ids to filter API requests by
 *
 * @param customers All available customers
 * @param allowedCustomerTypes The allowed types of customer to filter by for this entity
 * @param currentFilters The current set of global filters.
 * @param useIntegerID Customers can have integer or symbol id's. If
 *                               the endpoint you're using this for supports integer id's, you
 *                               want to use them.
 * @returns {Array}
 */
function getCustomerFilters(
  customers: ICustomer[],
  allowedCustomerTypes: TopicFilterNames[],
  currentFilters?: ITopicFilterState
): any {
  if (!customers) return undefined;
  if (!allowedCustomerTypes) return undefined;

  return allowedCustomerTypes.reduce(
    (acc: any[] | undefined, filter: TopicFilterNames) => {
      if (currentFilters && currentFilters[filter]) {
        const filterMatchesCustomerFeedType = findString(filter);

        const customer = customers.find((customer) => {
          if (filterMatchesCustomerFeedType(customer.feedType)) {
            if (customer.id === currentFilters[filter]) return true;
            if (customer.name === currentFilters[filter]) return true;
          }

          return false;
        });

        // @TODO define clearly what should happen if the selected customer to filter by
        // couldn't be found in the list of customers retrieved from the API.
        // We could throw an error here. For now, just return the accumulator.
        if (customer === undefined) return acc;

        const { id } = customer;

        if (Array.isArray(acc)) return [...acc, id];
        return [id];
      }

      return acc;
    },
    undefined
  );
}

export default getCustomerFilters;
